import { Part, PART_INITIAL_VALUES } from "../../../catalogs/models/Part";

export enum CarrierStatusCode {
	Empty = "E",
	AssemblyInProgress = "A",
	Complete = "C",
	SignedOff = "S",
	Installed = "I",
	Uninstalled = "U",
	Finished = "F",
	Inhibited = "X",
}

export interface Carrier extends Part {
	TopRollId: number | null;
	TopRollName: string | null;
	TopRollSelectedPassNumber: number | null;
	TopRollSelectedPassStatus: string | null;
	BottomRollId: number | null;
	BottomRollName: string | null;
	BottomRollSelectedPassNumber: number | null;
	BottomRollSelectedPassStatus: string | null;
	CarrierStatusCode: CarrierStatusCode;
	CarrierInstanceId: number | null;
	Bait: number | null;
	WeighUp: number | null;
	SectionId: number | null;
	SectionName: string | null;
	StandId: number | null;
	StandName: string | null;
	Stands: string;
	RollsetLetter: string;
	RollsetId: number | null;
	UpdatedAt: Date | null;
	CreatedAt: Date | null;
	SignedOffAt: Date | null;
	SignOffOperatorId: number | null;
	SignOffOperatorName: string | null;
	InstalledAt: Date | null;
	UninstalledAt: Date | null;
	DisassembledAt: Date | null;
	IsActive: boolean | null;
}

export const CARRIER_INITIAL_VALUES: Carrier = {
	...PART_INITIAL_VALUES,
	TopRollId: null,
	TopRollName: "",
	TopRollSelectedPassNumber: null,
	TopRollSelectedPassStatus: null,
	BottomRollId: null,
	BottomRollName: "",
	BottomRollSelectedPassNumber: null,
	BottomRollSelectedPassStatus: null,
	CarrierStatusCode: CarrierStatusCode.Empty,
	CarrierInstanceId: null,
	Bait: null,
	WeighUp: null,
	SectionId: null,
	SectionName: "",
	StandId: null,
	StandName: "",
	Stands: "",
	RollsetLetter: "",
	RollsetId: null,
	UpdatedAt: null,
	CreatedAt: null,
	SignedOffAt: null,
	SignOffOperatorId: null,
	SignOffOperatorName: "",
	InstalledAt: null,
	UninstalledAt: null,
	DisassembledAt: null,
	IsActive: true,
};
